import {safeDefine} from '@breuni-ui/safe-define';
import {CarouselNavigationPrev} from '@breuni-ui/carousel';

export default class EntsNavigationPrev extends CarouselNavigationPrev {
}

safeDefine('ents-carousel-navi-prev', EntsNavigationPrev);

